soda-coupon-cell---coupon.useRuleWeekDay.Monday
soda-coupon-cell---coupon.useRuleWeekDay.Tuesday
soda-coupon-cell---coupon.useRuleWeekDay.Wednesday
soda-coupon-cell---coupon.useRuleWeekDay.Thursday
soda-coupon-cell---coupon.useRuleWeekDay.Friday
soda-coupon-cell---coupon.useRuleWeekDay.Saturday
soda-coupon-cell---coupon.useRuleWeekDay.Sunday
soda-coupon-cell---coupon.payTypeList.card
soda-coupon-cell---coupon.payTypeList.money
soda-coupon-cell---coupon.payTypeList.all
soda-coupon-cell---coupon.payTypeList.pos
soda-coupon-cell---coupon.payTypeList.pay
soda-coupon-cell---coupon.costType.order
soda-coupon-cell---coupon.costType.meals
soda-coupon-cell---coupon.costType.delivery
soda-coupon-cell---coupon.other.use
soda-coupon-cell---coupon.other.min
soda-coupon-cell---coupon.other.max
soda-coupon-cell---coupon.other.time
soda-coupon-cell---coupon.other.cost
soda-coupon-cell---coupon.other.limit
soda-coupon-cell---coupon.other.limitUse
soda-coupon-cell---coupon.other.new
soda-coupon-cell---coupon.other.cardBin
soda-coupon-cell---coupon.other.off
soda-coupon-cell---coupon.other.hide
soda-coupon-cell---coupon.other.show
FoodOpC_Notifications_Full_time_tbyY
FoodOpC_Notifications_Full_service_HBkd
FoodOpC_Notifications_No_order_CPhU
FoodOpC_Notifications_All_payments_ERiC
FoodOpC_Notifications_All_stores_lcyT
FoodOpC_Notifications_Some_stores_BdsO